module.exports = __webpack_public_path__ + "static/media/repair.efd9b159.svg";